import React from 'react'

export default function TermsofUse() {
  return (
    <div className="about-us">

        <h1>Terms of Use</h1>
      <p>
        By using <strong>WalkNow</strong>, you agree to these terms. If not, please do not use the platform.
      </p>

      <h2>1. Eligibility</h2>
      <p>You must be at least 16 years old.</p>

      <h2>2. Permitted Use</h2>
      <ul>
        <li>Browse and apply for jobs</li>
        <li>Employers may post legitimate walk-in opportunities</li>
      </ul>

      <h2>3. Prohibited Use</h2>
      <ul>
        <li>False information</li>
        <li>Spam or malicious activity</li>
        <li>Violation of any law or rights</li>
      </ul>

      <h2>4. Accounts</h2>
      <ul>
        <li>Maintain accurate info</li>
        <li>Keep credentials safe</li>
      </ul>

      <h2>5. Content</h2>
      <ul>
        <li>You own your uploads</li>
        <li>WalkNow owns platform content</li>
      </ul>

      <h2>6. Job Listings</h2>
      <ul>
        <li>No guarantee of job placement</li>
        <li>Verify interviews independently</li>
      </ul>

      <h2>7. Termination</h2>
      <p>We may suspend or terminate your access</p>

      <h2>8. Liability</h2>
      <ul>
        <li>Use at your own risk</li>
        <li>No liability for data loss or job outcomes</li>
      </ul>

      <h2>9. Governing Law</h2>
      <p>Subject to laws of India</p>

      <h2>10. Contact</h2>
      <p>Email: <a href="mailto:ram1711sai@gmail.com">ram1711sai@gmail.com</a></p>
   
    </div>
  )
}
